import { ApolloClient, NormalizedCacheObject } from '@apollo/client'

import { UserProfileSectionsDocument } from 'hooks/useQueries'

import profileSectionsVariables from './profileSectionsVariables'

type UserProfileSsr = {
  profile?: unknown
}

// Seeds the first page of the profile's stories/listings/reviews so the
// ProfileSections component renders from the SSR payload instead of fetching
// client-side. The id must match what ProfileSections passes (props.user.data.id)
// so the seed shares the consumer's Apollo cache key. writeQuery is synchronous —
// safe in mini_racer SSR.
const seedUserProfile = (
  client: ApolloClient<NormalizedCacheObject>,
  ssr: UserProfileSsr | undefined,
  id: string | number | undefined,
): void => {
  if (!ssr?.profile || id == null) return

  try {
    client.writeQuery({
      query: UserProfileSectionsDocument,
      variables: profileSectionsVariables(id),
      data: ssr.profile,
    })
  } catch {
    // Best-effort: a malformed payload must not break the render.
  }
}

export default seedUserProfile
